import type { AxiosResponse } from "axios";
import { createQuery } from "react-query-kit";

import type { IVideoVisitResults } from "@api/videoVisit/types";
import type { ID } from "@constants";
import type { IApiResponse, IAxiosFn } from "@/api";
import { axiosClient, AxiosError } from "@/api";

const key = "video-visit-results";

type IResponse = AxiosResponse<IApiResponse<IVideoVisitResults>>;
interface IVariables {
  appointmentId: ID;
}

export const getVideoVisitResult: IAxiosFn<IVariables, IResponse> = async (
  params,
  signal,
) => {
  return axiosClient.get(`video-visit/${params?.appointmentId}/results`, {
    params,
    signal,
  });
};

export const useVideoVisitResults = createQuery<
  IResponse,
  IVariables,
  AxiosError
>({
  primaryKey: key,
  queryFn: ({ queryKey: [_primaryKey, variables], signal }) =>
    getVideoVisitResult(variables, signal),
  retry(_failureCount, error) {
    return error.code !== AxiosError.ERR_BAD_REQUEST;
  },
});
